// helpers.js
// ========

export function getAvitoHtml (item) {
	var result = "<div class='left_item'>";
	// header block
	result += "<div class='title_block'>";
	result += "<a href='https://avito.ru"+item.urlPath+"' target='_blank' class='li_a'>"+item.title+"</a>";
	// description popup
	result += "<div class='title_right_block'>";
	result += "<div class='pano_btn'><a href='"+getYandexPanoramUrl(item)+"' target='_blank'><img src='https://yandex.ru/maps/favicon.svg' /></a></div>";
	result += "<div class='desc_btn'><div class='description'>"+getDescription(item)+"</div></div>";
	result += "</div>";
	result += "</div>";
	
	// image block
	result += "<div class='img_block'>";

		result += "<div class='img_loading'>";
		// image
		if ((item.images[0] !== undefined) && (item.images[0]['154x116'] !== undefined)){
			result += "<img src='"+item.images[0]['154x116']+"' />";
		} else {
			result += "<img src='/no-photo-154x116.png' />";
		}
		result += "</div>";
		
		result += "<div class='right_block'><div class='text_block'>";
				result += "<div class='price'>"/* +item.priceDetailed.title.short+": " */+item.priceDetailed.fullString+"</div>";
				result += "<div class='address'>"+item.geo.formattedAddress+"</div>";
				if (item.geo.geoReferences[0] !== undefined){
					if (item.geo.geoReferences[0].colors !== undefined){
						result += "<div class='metro'><i class='metro_marker' style='background-color: "+item.geo.geoReferences[0].colors[0]+";'></i>"+item.geo.geoReferences[0].content+item.geo.geoReferences[0].after+"</div>";
					} else {
						result += "<div class='metro'>"+item.geo.geoReferences[0].content+"</div>";
					}
				}
			result += "</div>";
			result += "<div class='date'>"+getDateInfo(item)+"</div>";
		result += "</div>";
	result += "</div>";
	
	result += "<div class='item_footer'>"+getFooter(item)+"</div>";
	
	result += "</div>";
	return result;
};


//https://yandex.ru/maps/2/saint-petersburg/?from=api-maps&l=stv,sta&ll=30.409711,59.950424&origin=jsapi21&panorama[direction]=36.151487,12.296131&panorama[full]=true&panorama[point]=30.407470,59.950888&panorama[span]=112.316839,60.000000&z=17
function getYandexPanoramUrl(item){
	var result = 'https://yandex.ru/maps/2/saint-petersburg/?from=api-maps&l=stv,sta&ll='+item.coords.lng+','+item.coords.lat+'&origin=jsapi21&panorama[direction]=0,0&panorama[full]=true&panorama[point]='+item.coords.lng+','+item.coords.lat+'&panorama[span]=112.316839,60.000000&z=17';
	//console.log(item);
	return result;
}
function getDescription(item){
	var result = '';
	var descInfo = '';
	const sellerInfo = getIvaPayload(item, 'UserInfoStep', 'seller-info');
	if (sellerInfo !== undefined){
		descInfo += "<a href='https://avito.ru"+sellerInfo.profile.link+"' target='_blank' class='li_a'>"+sellerInfo.profile.title+"</a>";
	} else {
		descInfo += "<span class='gray999'>Пользователь</span>";
	}
	descInfo += "<span class='desc_info_text'>"+item.closedItemsText+"</span>";
/* 	const sellerText = getIvaPayload(item, 'UserInfoStep', 'text');
	if (sellerText !== undefined){
		descInfo += "<span class='desc_info_text'>"+sellerText.value+"</span>";
	}
 */	result += "<div class='desc_info'>"+descInfo+"</div>";
	result += "<div class='desc_text'>"+item.description+"</div>";
	return result;
}

function getDateInfo(item){
	var date = '';
	const payload = getIvaPayload(item, 'DateInfoStep', 'date-info');
	if (payload !== undefined){
		date = payload.absolute;
	}
	return date;
}

function getFooter(item){
	var footer = '';
	//console.log(item);
	var item_type = 'type'+item.type_id;
	footer += '<input id="item_type0'+item.id+'" class="types_btn" type_id="0" obj_id="'+item.id+'" type="radio" name="item_type'+item.id+'"'+((item_type == 'type0') ? ' checked="checked"' : "")+'><label for="item_type0'+item.id+'" class="item_type0">Новый</label> ';
	footer += '<input id="item_type1'+item.id+'" class="types_btn" type_id="1" obj_id="'+item.id+'" type="radio" name="item_type'+item.id+'"'+((item_type == 'type1') ? ' checked="checked"' : "")+'><label for="item_type1'+item.id+'" class="item_type1">Отказ</label> ';
	footer += '<input id="item_type2'+item.id+'" class="types_btn" type_id="2" obj_id="'+item.id+'" type="radio" name="item_type'+item.id+'"'+((item_type == 'type2') ? ' checked="checked"' : "")+'><label for="item_type2'+item.id+'" class="item_type2">Не очень</label> ';
	footer += '<input id="item_type3'+item.id+'" class="types_btn" type_id="3" obj_id="'+item.id+'" type="radio" name="item_type'+item.id+'"'+((item_type == 'type3') ? ' checked="checked"' : "")+'><label for="item_type3'+item.id+'" class="item_type3">План?</label> ';
	footer += '<input id="item_type4'+item.id+'" class="types_btn" type_id="4" obj_id="'+item.id+'" type="radio" name="item_type'+item.id+'"'+((item_type == 'type4') ? ' checked="checked"' : "")+'><label for="item_type4'+item.id+'" class="item_type4">Интересно</label> ';
	
	return footer;
}


function getIvaPayload(item, param, componentData){
	var payload;
	if (item.iva[param][0] !== undefined){
		var tmpArr = item.iva[param];
		for(var i=0;i<tmpArr.length;i++){
			if (tmpArr[i].componentData.component !== undefined){
				if (tmpArr[i].componentData.component == componentData){
					payload = tmpArr[i].payload;
					break;
				}
			}
		}
	}
	return payload;
}

// export function getLoadingHtml(gif='loading3'){
	// var result = '<div class="loading '+gif+'"></div>';
	// return result;	
// };

export function setDescriptionEvents() {
	var span = document.querySelectorAll('.desc_btn');
	var popupDesc = document.getElementById('obj-popup-description');
	var innerPopup = document.getElementById('obj-inner-popup');
	var t;
	//console.log(span);
	for (var i = span.length; i--;) {
		(function () {
			span[i].onmouseover = function () {
				//hideAll();
				clearTimeout(t);
				innerPopup.innerHTML = this.querySelector('.description').innerHTML.replace(/\n/g, "<br />");
				popupDesc.className = 'obj-popup-description';
				//this.className = 'desc_btn_hover';
			};
			span[i].onmouseout = function () {
				var self = this;
				t = setTimeout(function () {
					popupDesc.className = 'obj-popup-description-hidden';
					//self.className = 'desc_btn';
				}, 300);
			};
		})();
	}

	popupDesc.onmouseover = function () {
		clearTimeout(t);
	};
	popupDesc.onmouseout = function () {
		t = setTimeout(function () {
			popupDesc.className = 'obj-popup-description-hidden';
		}, 300);
	};

}

export async function getJson(url){				//=========== CURL JSON ===========
	var allCookies = document.cookie;
//	console.log(allCookies);
	var response = await fetch(url,
	{
		method: 'GET',
		mode: 'cors',
		headers: {},
	}).then(response => response.json());
//	console.log(url, response);
	return response;
}
//========================================

export function multiplyVectors(A, B){
	if (A.length !== B.length){return false;}
	var C = [];
	for (var i = 0; i < A.length; i++) C[i] = A[i]*B[i];
	return C;
}
